import {date, object, string} from 'yup';
import {COUNTRIES_UPPERCASE} from '../../../../../../../constants/countries';
import {fileSchema} from "../../../../../FormHandlers";

const countriesIds = COUNTRIES_UPPERCASE.map((el) => el[1])

export default (totalShares) => object({
  full_name: string().trim().required(),
  birthdate: date().required(),
  country_of_residence: string().required().oneOf(countriesIds),
  country_of_birth: string().required().oneOf(countriesIds),
  identity_doc: string().trim().required(),
  owner_percent: string()
    .test("less-than-20", "Should be 20% or higher", (value) => Number(value) >= 20)
    .test("higher-than-100", "Should be lower than 100%", (value) => Number(value) <= 100)
    .test("higher-than-total-shares", "Total shares exceeds 100%", (value) => (Number(value) + Number(totalShares)) <= 100)
    .test("is-nan", "Must be a number", (value) => !isNaN(value))
    .required(),

  owner_document_identity: fileSchema,
  owner_document_address: fileSchema,
});
